module.exports = __webpack_public_path__ + "static/media/laboratory.b915a2d7.svg";